import { AvatarDropdown } from "../Controls/AvatarDropdown";
import Logo from "../Login/Logo";
import React from "react";
import EncryptionSettings from "../Controls/EncryptionSettings";
import KeySyncButton from "../Controls/KeySyncButton";

const NavBar: React.FC = () => {
  return (
    // Static flex child (not fixed): the layout root is a flex column, so pinning
    // via `fixed` + an mt-14 offset on <main> was redundant, and fixed elements
    // misbehave on iOS when the on-screen keyboard opens.
    <nav className="flex flex-row items-center justify-between w-full p-2 bg-white border-b h-14 shrink-0 border-neutral-300">
      <div className="text-neutral-700">
        <Logo />
      </div>
      <div className="flex items-center gap-2">
        {/* No gap: the sync button reads as part of the shield control. */}
        <div className="flex items-center">
          <KeySyncButton />
          <EncryptionSettings />
        </div>
        <AvatarDropdown />
      </div>
    </nav>
  );
};

export default NavBar;
